import { gql } from 'apollo-angular';

export const alarmListQuery = gql`
  query AlarmList {
    alarmList {
      id
      name
      status
      lastUpdate
      condition
      enabled
      propertiesCriteria
      groupsCriteria
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      assetType
      type
      metric {
        id
        name
      }
      thresholdType
      thresholdValue
      notificationsContacts
      description
      delay
      category
    }
  }
`;

export const alarmLogsListQuery = gql`
  query AlarmLogsList {
    alarmLogsList {
      id
      name
      status
      category
      conditionString
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      triggerTime
      acknowledgedBy {
        id
        name
        lastName
        imgUrl
        email
        role
        phone
      }
    }
  }
`;

export const alarmSelectOptionsQuery = gql`
  query AlarmSelectOptions {
    alarmList {
      id
      name
    }
  }
`;

export const createAlarmMutation = gql`
  mutation CreateAlarm($input: AlarmInput!) {
    createAlarm(input: $input) {
      id
      name
      status
      lastUpdate
      condition
      enabled
      propertiesCriteria,
      groupsCriteria,
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      assetType
      type
      metric {
        id
        name
      }
      thresholdType
      thresholdValue
      notificationsContacts
      description
      delay
      category
    }
  }
`;

export const updateAlarmMutation = gql`
  mutation UpdateAlarm($id: ID!, $input: AlarmInput!) {
    updateAlarm(id: $id, input: $input) {
      id
      name
      status
      lastUpdate
      condition
      enabled
      propertiesCriteria
      groupsCriteria
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      assetType
      type
      metric {
        id
        name
      }
      thresholdType
      thresholdValue
      notificationsContacts 
      description
      delay
      category
    }
  }
`;

export const toggleAlarmsEnabledCtrlMutation = gql`
  mutation ToggleAlarmsEnabledCtrl($input: [ToggleAlarmsInput!]!) {
    toggleAlarmsEnabledCtrl(input: $input) {
      id
      enabled
    }
  }
`;

export const deleteAlarmsMutation = gql`
  mutation DeleteAlarms($ids: [ID!]!) {
    deleteAlarms(ids: $ids) {
      id
      name
      status
      lastUpdate
      condition
      enabled
      propertiesCriteria
      groupsCriteria
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      assetType
      type
      metric {
        id
        name
      }
      thresholdType
      thresholdValue
      notificationsContacts
      description
    }
  }
`;

export const acknowledgeAlarmMutation = gql`
  mutation AcknowledgeAlarm($id: ID!) {
    acknowledgeAlarm(id: $id) {
      id
      name
      status
      category
      conditionString
      properties {
        id
        name
      }
      groups {
        id
        name
      }
      devices {
        id
        name
      }
      triggerTime
      acknowledgedBy {
        id
        name
        lastName
        imgUrl
        email
        role
        phone
      }
    }
  }
`;

export const alarmsLogsExportQuery = gql`
  query AlarmsLogsExport($fromTs: AWSDateTime, $toTs: AWSDateTime) {
    alarmsLogsExport(fromTs: $fromTs, toTs: $toTs) {
      id
      filename
      contentType
      size
      content
    }
  }
`;
